import { StatusReferenceBase } from "./status-reference.base"

export class OrderPaymentStatusReferenceModel extends StatusReferenceBase {
    public orderPaymentStatusCode: string;
    public orderPaymentStatusName: string;   
    public statusCode: string;
    public highlightColor: string;
}